<template>
	<el-dialog title="编辑机构" v-model="isEdit" width="80%" center :close-on-click-modal="false"
		@closed="dialogClosedHandle">
		<div class="dialog-container" style="max-height: 600px; overflow: auto">
			<p class="platTitle">基础信息</p>
			<div class="info-input-container">
				<div class="flex flex-y-center flex-wrap">
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>机构名称</span>
						</div>
						<el-input :disabled="pageType == 'detail' ? true : false" v-model="orgName"
							class="platItemRigth" placeholder="请输入" />
					</div>
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span>机构简称</span>
						</div>
						<el-input :disabled="pageType == 'detail' ? true : false" v-model="orgSname"
							class="platItemRigth" placeholder="请输入" />
					</div>
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>机构类型</span>
						</div>
						<div class="flex platItemRigth flex-y-center">
							<el-select v-model="orgType" placeholder="请选择机构类型">
								<el-option label="平台机构" value="0" />
								<el-option label="物流公司" value="1" />
								<el-option label="LNG运输公司" value="2" />
							</el-select>
						</div>
					</div>
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span>机构描述</span>
						</div>
						<el-input :disabled="pageType == 'detail' ? true : false" v-model="orgNote"
							class="platItemRigth" placeholder="请输入" />
					</div>
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>联系人</span>
						</div>
						<el-input :disabled="pageType == 'detail' ? true : false" v-model="orgContact"
							class="platItemRigth" placeholder="请输入" />
					</div>
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span>所在区域</span>
						</div>
						<div class="flex platItemRigth flex-y-center">
							<el-select v-model="orgProvince" placeholder="请选择省" @change="getConProvince($event)">
								<el-option v-for="item in provinceList" :key="item.code" :label="item.name"
									:value="item.code" />
							</el-select>
							<el-select v-model="orgCity" placeholder="请选择市" @change="getConCity($event)">
								<el-option v-for="item in cityList" :key="item.code" :label="item.name"
									:value="item.code" />
							</el-select>
							<el-select placeholder="请选择区县" v-model="orgArea">
								<el-option v-for="item in areaList" :key="item.code" :label="item.name"
									:value="item.code" />
							</el-select>
						</div>
					</div>
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>联系电话</span>
						</div>
						<el-input :disabled="pageType == 'detail' ? true : false" v-model="orgPhone"
							class="platItemRigth" placeholder="请输入" />
					</div>
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span>详细地址</span>
						</div>
						<el-input :disabled="pageType == 'detail' ? true : false" v-model="orgAddr"
							class="platItemRigth" placeholder="请输入" />
					</div>
					
					
				</div>
			</div>
			<p class="platTitle">其他信息</p>
			<div class="info-input-container">
				<div class="flex flex-y-center flex-wrap">
					<div class="w50 platItem flex" style="align-items: flex-start">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>企业LOGO</span>
						</div>
						<div class="flex flex-y-center flex-x-between platItemRigth">
							<el-upload action="none" :show-file-list="false" :auto-upload="false" :multiple="false"
								:on-change="handleAddUploadChange" accept=".jpg,.jpeg,.png">
								<img v-if="orgLogo==''" src="@/assets/images/upload_img.png" alt="" srcset="" />
								<img v-else :src="orgLogo" alt="" srcset="" />
							</el-upload>
						</div>

					</div>
				</div>
			</div>


			<div class="footer_btn_warp">
				<template v-if="pageType != 'detail'">
					<div class="cancle_btn" v-on:click="closeModal()">取消</div>
					<div class="confirm_btn" v-on:click="submit()">确定</div>
				</template>
				<template v-else>
					<div class="cancle_btn" v-on:click="closeModal()">关闭</div>
				</template>
			</div>
		</div>
	</el-dialog>
</template>

<script>
	import {
		defineComponent,
		reactive,
		toRefs,
		getCurrentInstance,
		onMounted,
		nextTick,
	} from "vue";
	import {
		imgFileToBase64,
		isChinese
	} from "@/libs/tools";
	import {
		useStore
	} from "vuex";
	import {
		apiObj
	} from "@/config/api";
	export default defineComponent({
		name: "Edit",
		props: {
			sendData: {
				type: Object,
			},
		},
		emits: ["getData"],
		setup(props, context) {
			const store = useStore();
			const {
				proxy
			} = getCurrentInstance();

			const getData = () => {
				context.emit("getData");
			};
			onMounted(() => {
				nextTick(() => {
					getProvinceList();
				});
			});
			const data = reactive({
				isEdit: false,
				orgId: "",
				provinceList: [], //省
				cityList: [], //市
				areaList: [], //区县

				orgName: "富庚世达物流",
				orgSname: "FG",
				orgNote: "111",
				orgLogo: "",
				orgProperty: "enterprise",
				orgType: "1",
				orgCategory: 0,
				orgProvince: "",
				orgCity: "",
				orgArea: "",
				orgStreet: "",
				orgAddr: "",
				orgLng: "",
				orgLat: "",
				orgDuties: null,
				orgContact: "",
				orgPhone: "",
				orgDuties2: null,
				orgContact2: null,
				orgPhone2: null,
			});
			//重置数据
			const init = async (id) => {
				data.isEdit = true;
				data.orgId = id;

				let params = {
					orgId: id,
				};
				const r = await proxy.$http.get(apiObj.orgDetail, params);
				if (r) {
					data.orgName = r.orgInfo.orgName;
					data.orgSname = r.orgInfo.orgSname;
					data.orgNote = r.orgInfo.orgNote;
					data.orgLogo = r.orgInfo.orgLogo;
					data.orgProperty = r.orgInfo.orgProperty;
					data.orgType = r.orgInfo.orgType;
					data.orgCategory = r.orgInfo.orgCategory;
					data.orgProvince = r.orgInfo.orgProvince;
					data.orgCity = r.orgInfo.orgCity;
					getCityList(data.orgProvince);
					data.orgArea = r.orgInfo.orgArea;
					getAreaList(data.orgCity);
					data.orgStreet = r.orgInfo.orgStreet;
					data.orgAddr = r.orgInfo.orgAddr;
					data.orgLng = r.orgInfo.orgLng;
					data.orgLat = r.orgInfo.orgLat;
					data.orgDuties = r.orgInfo.orgDuties;
					data.orgContact = r.orgInfo.orgContact;
					data.orgPhone = r.orgInfo.orgPhone;
					data.orgDuties2 = r.orgInfo.orgDuties2;
					data.orgContact2 = r.orgInfo.orgContact2;
					data.orgPhone2 = r.orgInfo.orgPhone2;
				}
			};

			const dialogClosedHandle = () => {
				data.isEdit = false;
			};
			const closeModal = () => {
				data.isEdit = false;
			};
			const submit = async () => {
				if (data.driName == "") {
					proxy.$message.error("请填写司机名称");
					return;
				}
				if (data.driPhone == "") {
					proxy.$message.error("请填写手机号");
					return;
				}

				let params = {
					orgId: data.orgId,
					orgName: data.orgName,
					orgSname: data.orgSname,
					orgNote: data.orgNote,
					orgLogo: data.orgLogo,
					orgProperty: data.orgProperty,
					orgType: data.orgType,
					orgCategory: data.orgCategory,
					orgProvince: data.orgProvince,
					orgCity: data.orgCity,
					orgArea: data.orgArea,
					orgStreet: data.orgStreet,
					orgAddr: data.orgAddr,
					orgLng: data.orgLng,
					orgLat: data.orgLat,
					orgDuties: data.orgDuties,
					orgContact: data.orgContact,
					orgPhone: data.orgPhone,
					orgDuties2: data.orgDuties2,
					orgContact2: data.orgContact2,
					orgPhone2: data.orgPhone2

				}

				const r = await proxy.$http.post(apiObj.orgUpdate, params)
				console.log(r);
				if (r.code === 0 || r.respCode === '0000') {
					proxy.$message.success(r.msg || r.respMsg);
					getData();
					data.isEdit = false;
				} else {
					proxy.$message.error(r.msg || r.respMsg);
				}
			};
			//数组去重
			const uniqueArr = (array = []) => {
				var n = []; //一个新的临时数组
				//遍历当前数组
				for (var i = 0; i < array.length; i++) {
					//如果当前数组的第i已经保存进了临时数组，那么跳过，
					//否则把当前项push到临时数组里面
					if (n.indexOf(array[i]) == -1) n.push(array[i]);
				}
				return n;
			};
			const getProvinceList = async () => {
				let params = {
					page: 1,
					limit: 10000,
				};
				const res = await proxy.$http.get("/admin/bdzl/province/list", params);
				console.log(res);
				if (res.code == 0) {
					data.provinceList = res.rows;
				}
			};

			const getConProvince = (ev) => {
				console.log(ev);
				data.cityList = [];
				data.orgCity = "";
				data.areaList = [];
				data.orgArea = "";
				getCityList(ev);
			};

			const getCityList = async (code) => {
				let params = {
					provinceCode: code,
					page: 1,
					limit: 10000,
				};
				const res = await proxy.$http.get("/admin/bdzl/city/list", params);
				console.log(res);
				if (res.code === 0) {
					data.cityList = res.rows;
				}
			};

			const getConCity = (ev) => {
				data.areaList = [];
				data.orgArea = "";
				getAreaList(ev);
			};

			const getAreaList = async (code) => {
				let params = {
					cityCode: code,
					page: 1,
					limit: 10000,
				};
				const res = await proxy.$http.get("/admin/bdzl/area/list", params);
				console.log(res);
				if (res.code == 0) {
					data.areaList = res.rows;
				}
			};
			
			//上传图片
			const handleAddUploadChange = (file) => {
				const isLt2M = file.raw.size / 1024 / 1024 < 2;
			
				if (isLt2M == false) {
					proxy.$message.error("请上传小于2M的图片");
					return;
				}
				imgFileToBase64(file, (imageUrl) => {
					if (data.orgLogo.indexOf("https://") !== -1) {
						removeImgUrl(data.orgLogo);
					}
					data.orgLogo = imageUrl;
				});
			};
			
			//删除图片
			const removeImgUrl = async (imageUrl) => {
				await proxy.$http.post("/biz/bdzl/rptInfo/removeUrl", {
						url: imageUrl
					})
					.then((res) => {});
			};

			return {
				...toRefs(data),
				init,
				closeModal,
				getData,
				dialogClosedHandle,
				submit,
				uniqueArr,
				getConProvince,
				getConCity,
				handleAddUploadChange,
			};
		},
	});
</script>
<style scoped>
	.page_warp {
		width: 100%;
		max-height: 600px;
	}

	.input_row {
		width: 100%;
		height: 50px;
		display: flex;
		align-items: center;
	}

	.input_lable {
		width: 80px;
		text-align: right;
	}

	.input_box {
		width: 50%;
	}

	.input_tree_warp {
		width: calc(100% - 30px);
		height: 300px;
		margin-left: 30px;

		box-sizing: border-box;
		margin-top: 10px;
		display: flex;
		justify-content: space-between;
	}

	.manage {
		width: 48%;
		height: 100%;

		display: flex;
	}

	.tree {
		width: calc(100% - 80px);
		height: 100%;
		overflow: auto;
	}

	.footer_btn_warp {
		width: 100%;
		height: 70px;
		margin-top: 30px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.cancle_btn {
		width: 116px;
		height: 38px;
		background: #e36a19;
		border-radius: 4px;
		text-align: center;
		color: #fff;
		font-size: 14px;
		line-height: 38px;
		cursor: pointer;
		margin-right: 90px;
	}

	.confirm_btn {
		width: 116px;
		height: 38px;
		background: #293787;
		border-radius: 4px;
		text-align: center;
		color: #fff;
		font-size: 14px;
		line-height: 38px;
		cursor: pointer;
	}

	.platTitle {
		line-height: 100px;
		font-size: 18px;
		color: #000;
		font-weight: 600;
		position: relative;
		padding-left: 20px;
	}

	.platTitle::before {
		content: "";
		width: 4px;
		height: 18px;
		background: #20ca68;
		border-radius: 2px;
		position: absolute;
		top: 42px;
		left: 10px;
	}

	.platItem {
		margin-bottom: 20px;
	}

	.platItemLeft {
		min-width: 80px;
		justify-content: flex-end;
	}

	.platItem input {
		width: 80%;
		height: 38px;
		border: 1px solid #ededed;
		border-radius: 4px;
		padding-left: 20px;
		box-sizing: border-box;
	}

	.platItemRigth {
		width: 80%;
		padding-left: 20px;
		box-sizing: border-box;
	}

	.platItemRigth img {
		width: 150px;
		height: 150px;
	}

	.dialog-footer {
		width: 100%;
		height: 70px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.btn {
		padding: 5px 15px;
		font-size: 14px;
		border-radius: 5px;
		cursor: pointer;
	}
</style>